var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.amount,
        expression: "amount",
      },
    ],
    ref: "numeric",
    attrs: {
      placeholder: _vm.placeholder,
      type: "tel",
      readonly: _vm.readonly,
    },
    domProps: { value: _vm.amount },
    on: {
      blur: _vm.onBlurHandler,
      input: [
        function ($event) {
          if ($event.target.composing) return
          _vm.amount = $event.target.value
        },
        _vm.onInputHandler,
      ],
      focus: _vm.onFocusHandler,
      keypress: function ($event) {
        return _vm.numbersOnly($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }